// extracted by mini-css-extract-plugin
export default {"header":"main-wrapper-page_header__ZsENC","footer":"main-wrapper-page_footer__4SeLt"};